const prod = { BASE_URL: 'https://admin.marpewellbeing.uk' };
const dev = { BASE_URL: 'https://storm.ualegion.com' };
export const config = process.env.REACT_APP_STAGE === 'development' ? dev : prod;
